import { locales } from '@pkg/config/languages';
import { allCountries } from '@pkg/config/misc/countries';
import { LOCALE_CODE } from '@pkg/config/languages/localeCodes';
import { ISOAlpha3To2 } from '@pkg/config/languages/countryIsoCodes3To2';
import { defaultLocale } from '@pkg/config/languages';

export function getCountry(localeCode: LOCALE_CODE) {
  return locales[localeCode].country;
}

export function getLanguageName(localeCode: LOCALE_CODE) {
  return locales[localeCode].languageName;
}

export function getIso(localeCode: LOCALE_CODE) {
  return locales[localeCode].countryIso;
}

export function getIso2Digit(localeCode: LOCALE_CODE) {
  return ISOAlpha3To2[getIso(localeCode) as keyof typeof ISOAlpha3To2];
}

export function getIcon(localeCode: LOCALE_CODE) {
  return locales[localeCode].icon;
}

export function getCurrency(localeCode: LOCALE_CODE) {
  return locales[localeCode].currency;
}

export function countryFromLocale(localeCode: LOCALE_CODE) {
  return allCountries.find(country => country.countryIso === getIso(localeCode));
}

export function getLanguageCodeFromLocale(localeCode: LOCALE_CODE) {
  const ensuredLocaleCode = localeCode || defaultLocale;
  const parsedCountryCode = ensuredLocaleCode?.substring(0, 2);
  return parsedCountryCode;
}

/**
 * Converts locale code to BCP 47 language tag for schema.org inLanguage.
 * e.g. "en-gb" → "en-GB", "da" → "da-DK", "es" → "es-ES"
 */
export function toBcp47LanguageTag(localeCode: LOCALE_CODE): string {
  if (localeCode.includes('-')) {
    return localeCode.replace(/-([a-z]{2})$/i, (_, region) => `-${region.toUpperCase()}`);
  }
  const countryCode = getIso2Digit(localeCode);
  return `${localeCode}-${countryCode}`;
}
